import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
const warningCss = "wdmmm4s";
const Warning = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(warningCss, props.className)} />;
});
export const TaxIdWarning = () => <Warning>
    {HtmlParser(I18n.t('publisher.billing.tax_id_not_valid_html'))}
  </Warning>;

require("./tax_id_warning.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./tax_id_warning.js");